export default "__VITE_ASSET__dec6367c__"